import { useEffect } from 'react';
import { useAssessmentsPaths } from '../hooks/useAssessmentsPaths';
import { initializeAssessmentsPendo, loadAssessmentsPendoScript } from './assessmentsPendoUtils';

/**
 * Pendo for the campaign assessments flow, kept apart from member-web's Pendo.
 * Account = tenantId, visitor = surveyEventId (both from the URL).
 */
export const useAssessmentsPendo = () => {
  const { tenantId, surveyEventId } = useAssessmentsPaths();

  useEffect(() => {
    loadAssessmentsPendoScript().then(() => {
      initializeAssessmentsPendo({ tenantId, surveyEventId });
    });
  }, [tenantId, surveyEventId]);
};
